.skipLink {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: 1000;
}

.skipLink:focus {
  position: fixed;
  left: 1rem;
  top: 1rem;
  width: auto;
  height: auto;
  padding: 0.5rem 1rem;
  background: var(--mantine-color-white);
  border: 2px solid var(--mantine-color-pachubColourScheme-6);
  border-radius: var(--mantine-radius-md);
  box-shadow: var(--mantine-shadow-md);
}
